/* eslint-disable complexity */
import React, { useRef, useEffect, useState } from "react";
import { Schedule } from "@/api/calendar";
import dayjs, { Dayjs } from "dayjs";
import "./index.less";
import { getRealColor, getTaskTimeForTooltip } from "@/components/Calendars/utils";
import { getTypeImage, getDefaultColor } from "@/components/Calendars/utils/getTypeImage";
import { useTranslation } from "react-i18next";
import _, { each } from "lodash";
import { message, Tooltip } from "antd";
import { connect } from "dvajs";
import bus from "@/utils/bus";
import TaskPopover from "@/components/Calendars/Task/TaskPopover";
import { TASK_STATUS } from "@/types/newWork";

function ViewTaskItem({
  schedule,
  styles,
  currentTime,
  changePersonalTaskDraw
}: {
  schedule: Schedule;
  styles: React.CSSProperties;
  currentTime: Dayjs;
  changePersonalTaskDraw: (taskId: string, visible: boolean) => void;
}) {
  let scheduleStart = schedule.scheduleBeginTime || dayjs(schedule.beginTime);
  let scheduleEnd = schedule.scheduleEndTime || dayjs(schedule.endTime);
  const { t } = useTranslation("calendar");
  const timePast = scheduleEnd.isBefore(dayjs());
  const start = scheduleStart.format("HH:mm");
  const end = scheduleEnd.format("HH:mm");
  const color = getRealColor(schedule.color || schedule.calendarInfo?.color);
  schedule.color = schedule.color || getDefaultColor();
  const itemRef: any = useRef(null);
  const [hover, setHover] = useState(false);
  const backgroundColor = hover ? "rgba(222,237,255,1)" : "#FFFFFF";
  const hasMessage: any = useRef(false);
  const isMouseMove: any = useRef(false);

  return (
    <TaskPopover item={schedule} key={schedule.scheduleId}>
      <Tooltip
        overlayClassName="calendar-view-title-tooltip"
        title={getTaskTimeForTooltip(schedule, true, currentTime, t)}
      >
        <div
          className={`view-schedule-item ${timePast ? "schedule-timepast" : ""}`}
          style={{
            backgroundColor: backgroundColor,
            color: "#000000",
            ...styles
          }}
          onMouseEnter={(e: any) => {
            setHover(true);
          }}
          onMouseLeave={() => {
            setHover(false);
          }}
          onMouseDown={(e: any) => {
            e.persist();
            e.stopPropagation();
            isMouseMove.current = true;
          }}
          onMouseMove={(e: any) => {
            e.persist();
            e.stopPropagation();
            if (!isMouseMove.current || hasMessage.current) return;
            hasMessage.current = true;
            return message.warning(t("dragging to modify tasks is not supported")).then(
              () => {
                isMouseMove.current = false;
                hasMessage.current = false;
                return;
              },
              () => {
                isMouseMove.current = false;
                hasMessage.current = false;
                return;
              }
            );
          }}
          onMouseUp={(e: any) => {
            e.persist();
            e.stopPropagation();
            isMouseMove.current = false;
          }}
          onClick={(e: any) => {
            e.persist();
            e.stopPropagation();
            if (schedule.taskId) {
              changePersonalTaskDraw(schedule.taskId, true);
            }
          }}
          ref={itemRef}
        >
          <div
            className={`pre-circle-task pre-circle-task-${
              schedule.dueTag ? 4 : schedule.taskStatus
            }`}
          >
            <div
              className="pre-circle"
              style={{
                backgroundImage: `url(${getTypeImage(schedule.color)})`
              }}
            />
          </div>

          <div className="view-schedule-item-content">
            <div
              className={`title ${
                !schedule.dueTag &&
                (schedule.taskStatus === TASK_STATUS.FINISHED ||
                  schedule.taskStatus === TASK_STATUS.ABORT)
                  ? "title-decoration"
                  : ""
              }`}
            >
              {schedule.title}
            </div>
            <div className="time">{`${start}-${end}`}</div>
          </div>
        </div>
      </Tooltip>
    </TaskPopover>
  );
}

function mapStateToProps({ user }: any) {
  return {
    userData: user.userData.user
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changePersonalTaskDraw: (taskId: string, visible: boolean) =>
      dispatch({
        type: "work/changePersonalTaskDraw",
        payload: { taskId, drawVisible: visible }
      })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewTaskItem);
